import { createSelector } from 'reselect';

const getState = (state) => state.errors;

const getErrors = createSelector(getState, (errors) => errors);

export default {
  getErrors,
};
